<ng-container *appTranslate="let t">
  <p-toast position="bottom-right" />

  <p-toast [key]="translationProposalKey" position="bottom-center">
    <ng-template #message let-message>
      <div class="p-toast-message-icon">
        <i [class]="message.icon"></i>
      </div>

      <div class="p-toast-message-text">
        <div class="p-toast-summary">{{ message.summary }}</div>
        <div class="p-toast-detail">{{ message.detail }}</div>

        <new-ui-button
          [styleClass]="specialClassName"
          [fluid]="true"
          [label]="t('translationProposal.turnOff')"
          icon="pi pi-language"
          variant="outlined"
          severity="danger"
          (onClick)="exitTranslationProposal()"
        />
      </div>
    </ng-template>
  </p-toast>

  <p-toast [key]="candidateFieldDiffKey" position="bottom-center">
    <ng-template #message let-message>
      <div class="p-toast-message-icon">
        <i [class]="message.icon"></i>
      </div>

      <div class="p-toast-message-text">
        <div class="p-toast-summary">{{ message.summary }}</div>
        <div class="p-toast-detail">{{ message.detail }}</div>

        <new-ui-button
          [styleClass]="specialClassName"
          [fluid]="true"
          [label]="t('differences.perFieldExit')"
          icon="pi pi-language"
          variant="outlined"
          severity="danger"
          (onClick)="exitCandidateFieldDiff()"
        />
      </div>
    </ng-template>
  </p-toast>
</ng-container>
